import ExtraContent from './ExtraContent';

export default ExtraContent;
